import './style.less'
import * as React from 'react'
import {Surface} from 'telstra-ui/components/surface/Surface'
import {SurfaceList, SurfaceListItem} from 'telstra-ui/components/list/List'
import {Button} from 'telstra-ui/components/button/Button'
import {useCheckMobileScreen} from '@hooks/check-mobile-view'
import { isStoreIntAvailable } from '@applications/self-service-store'

const cardTitle: string = 'StoreInt services'

export const StoreIntCardLoadingIndicator = () => {
  const skeltonLoading = true
  const loadingClassName = 'tl-loading'
  const headerClassName = '__heading ' + loadingClassName
  const {isMobileView} = useCheckMobileScreen()
  const cardHeight = isMobileView ? {height: '480px'} : {height: '424px'}
  return (
    <div
      className="tc-mobility-services-container"
      style={isStoreIntAvailable() ? cardHeight : {height: '320px'}}
    >
      <Surface className="tl-custom-width tl-surface-dashboard ui-card-loading" name="surface-flat">
        <div className="tl-card-inner-content">
          <SurfaceList
            header={
              <div className="tl-heading__container">
                <div className={headerClassName}>{cardTitle}</div>
              </div>
            }
            body={
              <>
                <SurfaceListItem
                  itemHeading={'Adaptive StoreInt Plan'}
                  itemIcon={'icon-system-chevron-right'}
                  itemId={11}
                  skeltonLoading={skeltonLoading}
                />

                <SurfaceListItem
                  itemHeading={'Enterprise Wireless'}
                  itemIcon={'icon-system-chevron-right'}
                  itemId={12}
                  skeltonLoading={skeltonLoading}
                />
              </>
            }
            footer={
              <div className="tile-link-wrapper __button tl-list-footer-button">
                <div className="tc-service-changes-button">
                  <Button
                    variant="primary"
                    size="xSmall"
                    className={loadingClassName}
                    disabled={skeltonLoading}
                  >
                    Service changes
                  </Button>
                </div>
                <div className="tc-service-usage-button">
                  <Button variant="super" className={loadingClassName} disabled={skeltonLoading}>
                    Service usage
                  </Button>
                </div>
              </div>
            }
          />
        </div>
      </Surface>
    </div>
  )
}
